import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';
import ab from '../assets/images/9.jpg';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const FlightApi = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	function progressBarScroll() {
		let winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight,
			scrolled = (winScroll / height) * 100;
		document.getElementById('progressBar').style.width = scrolled + '%';
	}

	window.onscroll = function () {
		progressBarScroll();
	};
	return (
		<div>
			<Navbar />
			<div className='header' style={{ marginTop: 80 }}>
				<div className='progress-container'>
					<div className='progress-bar' id='progressBar'></div>
				</div>
			</div>
			<div
				style={{
					backgroundImage: `url(${ab})`,
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'black', padding: 10 }}>
					FLIGHT API INTEGRATION
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'black' }}>
					FLIGHT API INTEGRATION
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					"Providing a Strong Foundation for Strong Advisories"
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={12}>
							<p>
								APIs enable the interaction between the data, applications and
								devices. It delivers data between devices and programs. It helps
								to run the business easily and benefiting the users by providing
								real time service access on their device. In this modern world,
								the internet has become a fundamental piece of our life day by
								day. This faith in cell phones expands accomplished application
								improvement.
							</p>
							<br />
							<p>
								Application Program Interface or API for travel entrance
								constructs travel guides, courses, and other fundamental things
								that can enable the traveller to recognize a specific spot. On
								certain events, it may be utilized to find excursion spots,
								finding accommodation, guide, celebrated milestones, verifiable
								visiting spots, lodgings, and eateries. Along these lines,
								travellers can discover just by tapping their gadgets. The
								programming interface is a remarkable method of pulling up
								spreads in a short timeframe. In the Travel Industry to provide
								real-time bookings and inventory fetching Travel Agencies can
								integrate Airline or Flight Booking API, Hotel Booking API, Bus
								API, Car Booking API etc.
							</p>
							<br />
							<p>
								A Travel Web Portal is not complete unless it has the
								integration of Travel APIs Flight API, Hotel API, Bus API, Car
								API etc. Online Flight booking on our own website made it very
								easy and flexible with Flight API Integration in your Flight
								Booking Website.
							</p>
						</Grid>
					</Grid>
				</Container>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					What’s API Integration?
				</h1>
				<Divider />
			</div>
			<div style={{ padding: 10 }}>
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/flight-api-integration.jpg' />
						</Grid>
						<Grid item xs={8}>
							<p>
								An API integration is the connection among two or more online
								systems, via sharing their interfaces, that lets those systems
								exchange data or information. API integration control processes
								throughout many high-performing businesses that keep data in
								sync, heighten productivity and manage revenue. An online flight
								booking portal is not perfect until it has an integration of the
								Air API. Flight API helps Travel Portal business to get the
								flight availability and bookings done easily on real time basis.
								This booking engine helps the client to check and book Air
								ticket as per their convenience. Our Flight API is the most
								preferred as our GDS integration is a complete package focusing
								on low cost air carriers.
							</p>
						</Grid>
					</Grid>
				</Container>
			</div>

			<div style={{ background: '#0a74c0', padding: 13 }}>
				<Container>
					<p style={{ color: 'white', fontSize: 14 }}>
						How does API Integration help to improve the growth of your
						business?
					</p>
				</Container>
			</div>
			<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
				Why you Choose Arya Aviation for API Integration?
			</h1>
			<Divider />

			<Container style={{ marginTop: 10 }}>
				<p>
					At Arya Aviation, we provides most Robust Flight API Integration
					Solution to Modify and enhance your Online Travel Business Capability.
					Arya Aviation is the leading Flight API Provider delivering the best
					Flight API integration solution for business in the travel industry.
					Our Flight API Integration allows travellers to book flight tickets
					online, this plays an indispensable role in the development of
					technology enabled Travel Website nowadays. Integration of Flight APIs
					allows travel portals to offer available Airline options at a single
					place. The Flight API integration provides complete information like
					timing, fare, fare rules, availability of seats etc. about Airlines at
					one platform and helps travellers find the most convenient deals.
				</p>
				<p>
					Arya Aviation Flight API Integration System allows B2B Travel Agents
					and B2C Travel Websites to search and book GDS flights as well as LCC.
					Our smart cache system helps B2C Travel Agencies to maintain their
					look to book ratio with GDS suppliers. As per client requirements we
					provide Hold PNR system. This helps Travel Agents from the risk of
					fare rise or increase.
				</p>
			</Container>
			<Divider />
			<Container>
				<div style={{ padding: 10 }}>
					<Container style={{ marginTop: 20 }}>
						<Grid container spacing={4}>
							<Grid item xs={4}>
								<img src='https://aryaaviation.com/assets/images/apiIn.jpg' />
							</Grid>
							<Grid item xs={8}>
								<p>
									We also offers Ready-made or White Label Travel Portal
									Solutions having travel services like Flight Booking, Hotel
									Booking, Bus Booking and Car Booking for Travel Agency
									Start-ups who want to make OTA with a little investment of
									time and money. We have a great experience in Integration of
									major GDS Air suppliers APIs, Direct Airline APIs and 3rd
									Party consolidators. As per client business we have multiple
									Travel Portal Solution like B2C travel Portal, B2B Travel
									portal, B2B2B Travel Portal, B2E Travel Portal etc. Our Flight
									API features more than 250+ LCC airlines (low-cost carriers)
									and many more GDS carriers. We focus on continuous upgrading
									of our flight API to remain ahead of the competitors.
								</p>
								<br />
								<p>
									Arya Aviation provides a platform where reservations can be
									easily done with a cost-effective way to build travel booking
									applications and websites. We have served several clients and
									have developed the best portals using our flight API. Our
									Flight Booking API is available for B2C and B2B (Agents,
									Distributors and Super-Distributors).
								</p>
								<br />
								<p>
									Arya Aviation delivers best Flight Booking System in industry
									through Flight API Integration using its years of experience.
									Our Flight Booking system will allow your customers and agents
									to book online tickets easily. Your customers will have ease
									of checking flight timings, fares, availability all at one
									place and book the ticket as per their convenience.
								</p>
							</Grid>
						</Grid>
					</Container>
				</div>
			</Container>
			<Footer />
		</div>
	);
};

export default FlightApi;
